(() => {
  if (window.__tclInstallationInitialized) return;
  window.__tclInstallationInitialized = true;
  const roots = new WeakSet();

  function selectedVariantId(root) {
    return root.closest('product-info')?.querySelector('.product-variant-id')?.value || '';
  }

  function update(root, variantId) {
    const eligibleIds = new Set(root.dataset.tclEligibleVariantIds.split(',').filter(Boolean));
    const checkbox = root.querySelector('[data-tcl-installation-checkbox]');
    const details = root.querySelector('[data-tcl-installation-details]');
    const eligible = eligibleIds.has(String(variantId));

    root.hidden = !eligible;
    if (!eligible) checkbox.checked = false;
    if (!eligible || !checkbox.checked) {
      const dialog = root.querySelector('[data-tcl-installation-faq-dialog]');
      if (dialog?.open) dialog.close();
    }
    details.hidden = !eligible || !checkbox.checked;
    root.classList.toggle('is-selected', eligible && checkbox.checked);

    document.querySelectorAll('[data-tcl-installation-service]').forEach((input) => {
      if (input.dataset.tclSectionId !== root.dataset.tclSectionId) return;
      input.disabled = !eligible || !checkbox.checked;
    });
  }

  function initializeFaq(root) {
    const dialog = root.querySelector('[data-tcl-installation-faq-dialog]');
    const trigger = root.querySelector('[data-tcl-installation-faq-open]');
    if (!dialog || !trigger || dialog.dataset.tclFaqInitialized) return;
    dialog.dataset.tclFaqInitialized = 'true';

    trigger.addEventListener('click', () => {
      if (!dialog.open) dialog.showModal();
    });
    dialog.querySelector('[data-tcl-installation-faq-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (trigger.isConnected && !root.hidden) trigger.focus();
    });
  }

  function initialize(root) {
    if (roots.has(root)) return;
    roots.add(root);
    initializeFaq(root);
    root.querySelector('[data-tcl-installation-checkbox]').addEventListener('change', () => {
      update(root, selectedVariantId(root));
    });
    update(root, selectedVariantId(root));
  }

  function initializeAll(container = document) {
    container.querySelectorAll('[data-tcl-installation]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('product-info:loaded', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      document.querySelectorAll('[data-tcl-installation]').forEach((root) => {
        if (root.dataset.tclSectionId !== data.sectionId) return;
        initialize(root);
        update(root, data.variant?.id || '');
      });
    });
  }
})();
